export default function hoverTile(element) {
    // Require a valid DOM element
    if( ! element ) return

    // Require a touch device
    if( ! window.matchMedia('(any-hover: none)').matches ) return

    let active = false

    function handleClick(e) {

        const current = document.querySelector('.js-hovered')
        if( current ) {
            current.classList.remove('js-hovered')
        }

        if( !active ) {
            e.preventDefault()
            e.stopPropagation()
            active = true;
            element.classList.add('js-hovered')

            document.addEventListener('click', unhoverOnDocClick)
        }
    }

    function unhoverOnDocClick(e) {
        if( element !== e.target && !element.contains(e.target) ) {
            active = false;
            element.classList.remove('js-hovered')
        }
    }

    element.addEventListener('click', handleClick)
}